import { MetadataEntitiesClient, MetadataEntityCreateRequest, MetadataEntityUpdateRequest } from "@api/apiClient";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "@api/axiosInstance";

const client = new MetadataEntitiesClient(undefined, axios);

const SCENARIO_TYPE = "ScenarioType";
const SCENARIO_TYPE_QUERY_KEY = ["metadataEntities", SCENARIO_TYPE] as const;

export const SCENARIO_TYPE_UI_KEY = "scenario-type" as const;
export const SCENARIO_TYPE_BACKEND = SCENARIO_TYPE;

export const useScenarioTypeData = (options?: any) => {
  return useQuery({
    ...options,
    queryKey: SCENARIO_TYPE_QUERY_KEY,
    initialData: [],
    queryFn: async () => client.getMetaDataByType(SCENARIO_TYPE),
  });
};

export const useAddScenarioType = (options?: any) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...options,
    mutationFn: ({ value }: { value: string }) => {
      const createRequest = new MetadataEntityCreateRequest({
        name: value,
        type: SCENARIO_TYPE,
      });
      return client.createMetaDataEntity(createRequest);
    },
    onSuccess: (...args: unknown[]) => {
      queryClient.invalidateQueries({ queryKey: SCENARIO_TYPE_QUERY_KEY });
      options?.onSuccess?.(...args);
    },
  });
};

export const useUpdateScenarioType = (options?: any) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...options,
    mutationFn: (payload: MetadataEntityUpdateRequest) => client.updateMetaDataEntity(payload),
    onSuccess: (...args: unknown[]) => {
      queryClient.invalidateQueries({ queryKey: SCENARIO_TYPE_QUERY_KEY });
      options?.onSuccess?.(...args);
    },
  });
};

export const useDeleteScenarioType = (options?: any) => {
  const queryClient = useQueryClient();
  const { onSuccess: callerOnSuccess, ...rest } = options ?? {};
  return useMutation<boolean, unknown, { id: string }>({
    ...rest,
    mutationFn: ({ id }) => client.deleteMetaDataEntitybyId(id),
    onSuccess: (...args: unknown[]) => {
      queryClient.invalidateQueries({ queryKey: SCENARIO_TYPE_QUERY_KEY });
      callerOnSuccess?.(...args);
    },
  });
};
